module.exports = __webpack_public_path__ + "img/EventsHeader.b1972c5a.jpg";